import React from 'react';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import Slider from 'react-slick';

import css from './Partners.module.scss';

const Partners = ({ heading, hasBackground }) => {
	const settings = {
		infinite: true,
		speed: 500,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					autoplay: true,
					autoplaySpeed: 3000,
					centerMode: true,
					variableWidth: true,
				},
			},
		],
	};
	return (
		<>
			<Helmet>
				<link
					rel="stylesheet"
					type="text/css"
					charset="UTF-8"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
				/>
				<link
					rel="stylesheet"
					type="text/css"
					href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
				/>
			</Helmet>

			<div
				className={
					hasBackground
						? classNames(css.partners, css.hasBackground)
						: css.partners
				}
			>
				{heading && <h3>{heading}</h3>}
				<Slider {...settings} className={css.partnerImages}>
					<div className={css.slide}>
						<img
							src="/images/components/partners/lnt.png"
							alt="l and t mutual fund"
						/>
					</div>
					<div className={css.slide}>
						<img
							src="/images/components/partners/invesco.png"
							alt="invesco mutual fund"
						/>
					</div>
					<div className={css.slide}>
						<img
							src="/images/components/partners/kotak.png"
							alt="kotak mutual fund"
						/>
					</div>
					<div className={css.slide}>
						<img
							src="/images/components/partners/dsp.png"
							alt="dspmutual fund"
						/>
					</div>
					<div className={css.slide}>
						<img
							src="/images/components/partners/canara.png"
							alt="canara mutual fund"
						/>
					</div>
				</Slider>
			</div>
		</>
	);
};

export default Partners;
